var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 30,
    viewBox: "0 0 15 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6502 20.1615C14.6502 17.7603 13.3495 16.026 10.3146 14.3585L8.31357 13.2913V3.48615C9.81436 3.65291 11.2484 4.28657 12.4491 5.42049L13.9165 9.22247H14.0832V4.31992C12.6492 3.48615 10.348 2.91919 8.31357 2.85249V0.651345H7.98007V2.85249C3.51107 3.71961 0.97642 5.95411 0.97642 9.08907C0.97642 11.2235 1.97694 12.5242 4.8451 14.0917L7.98007 15.7926V26.2647H7.81331C5.71222 26.2647 3.74453 25.3642 2.11034 23.6967L0.809667 20.3283H0.642913V25.2975C2.64396 26.6315 4.5783 27.1985 7.11295 27.1985C7.41311 27.1318 7.71326 27.0317 7.98007 26.965V29.3663H8.31357V26.8316C12.4824 25.4643 14.6502 23.1964 14.6502 20.1615ZM6.54599 12.3241C3.81123 10.8567 2.81071 9.58933 2.81071 7.72169C2.81071 5.18704 4.7784 3.4528 7.61321 3.4528H7.98007V13.0912L6.54599 12.3241ZM8.31357 15.9593L8.61373 16.1261C11.5819 17.7603 12.8159 19.3611 12.8159 21.6289C12.8159 24.2636 11.0483 26.0646 8.31357 26.2313V15.9593Z",
    fill: "#030201"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.0e862f8983ace2fd8585a11cfbfef2b4.svg";
export { ForwardRef as ReactComponent };